import { Card, Form, Input, Row, Button, Space } from 'antd'
import {
  SearchOutlined,
  ReloadOutlined,
  DownloadOutlined,
} from '@ant-design/icons'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router'
import moment from 'moment'
import AuthComponent from '../../../components/AuthComponent'
/**
 *
 * @param {String} name 表单名称
 * @param {Array} fields 表单项列表
 * @param {Object} initialValues  表单初始值（不可接收可变值）
 * @param {Object} defaultValue  表单默认值（接收可变值插入表单项）
 * @param {Function} onSearch 提交方法
 * @param {Function} onExport 导出方法
 * @param {Object} authKey 权限
 * @param children 可插入更多按钮
 * @returns 表单组件
 */
const BasicForm = (props) => {
  const { state } = useLocation()
  const {
    defaultValue = {},
    name,
    width,
    fields = [],
    onSearch = () => {},
    onExport = () => {},
    onExportDetail = () => {},
    initialValues = {},
    authKey = { search: '', export: '' },
    children,
  } = props
  const [form] = Form.useForm()
  const onReset = () => {
    form.resetFields()
  }
  const handleExport = () => {
    onExport(form.getFieldValue())
  }
  const handleExportDetail = () => {
    onExportDetail(form.getFieldValue())
  }
  //获取时间默认值（缴款单明细表单）
  useEffect(() => {
    if (state && state.createTime && name == 'payment-list') {
      let createTime = [
        moment(state.createTime[0]),
        moment(state.createTime[1]).endOf('day'),
      ]
      form.setFieldsValue({ createTime })
    }
  }, [])
  useEffect(() => {
    form.setFieldsValue(defaultValue)
  }, [defaultValue])
  return (
    !!fields.length && (
      <Card style={{ marginBottom: '15px' }}>
        <Form
          name={name}
          layout="inline"
          form={form}
          onFinish={(fieldsValue) => {
            onSearch({ ...fieldsValue, pageIndex: 1 })
          }}
          initialValues={initialValues}
          style={{ marginBottom: '-10px' }}
        >
          {fields.map((item) => (
            <Form.Item
              label={item.label}
              name={item.name}
              key={item.name}
              style={{ marginBottom: '16px' }}
            >
              {item.component ? (
                item.component
              ) : (
                <Input
                  allowClear
                  style={{ width: item.width ? item.width : '200px' }}
                  placeholder={item.placeholder || '请输入内容'}
                />
              )}
            </Form.Item>
          ))}
          <AuthComponent authKey={authKey.search}>
            <Form.Item>
              <Button
                ghost
                type="primary"
                htmlType="submit"
                icon={<SearchOutlined />}
              >
                查询
              </Button>
            </Form.Item>
          </AuthComponent>
          <Form.Item>
            <Button
              ghost
              type="primary"
              icon={<ReloadOutlined />}
              onClick={onReset}
            >
              重置
            </Button>
          </Form.Item>
          <AuthComponent authKey={authKey.export}>
            <Form.Item>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleExport}
              >
                导出
              </Button>
            </Form.Item>
          </AuthComponent>
          <AuthComponent authKey={authKey.export}>
            <Form.Item>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={handleExportDetail}
              >
                商品明细导出
              </Button>
            </Form.Item>
          </AuthComponent>
          {children}
        </Form>
      </Card>
    )
  )
}
export default BasicForm
